import React from 'react';
/* eslint-disable */
import {
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const tableData = this.props.tableData;
    const searchData = this.props.searchData;
    const date = this.props.date;
    const totalValues = this.props.totalValues;

    const tableDataNew = tableData.map((obj) => ({
      ...obj,
      shortSupplyAmount:
        obj.quantity - obj.fulfilledQuantity < 0 ? 0 : obj.quantity - obj.fulfilledQuantity
    }));

    return (
      <div>
        <h3>
          <center>
            <u>Customer Order Details</u>
          </center>
        </h3>
        <div>&nbsp;</div>
        <h4>
          <center>{searchData.groupName}</center>
        </h4>
        <h4>
          <center>{date.toISOString().split('T')[0]}</center>
        </h4>
        <div>&nbsp;</div>
        <h4>
          <center>
            {'Total Orders : ' + tableData.length} &nbsp;&nbsp;&nbsp;&nbsp;{' '}
            {'Total Quantity : ' +
              totalValues.totalQtyKG.toFixed(2) +
              '(KG) | ' +
              totalValues.totalQtyUnit.toFixed(2) +
              '(UNIT)'}
            &nbsp;&nbsp;&nbsp;{' '}
            {'Total Fulfilled Quantity : ' +
              totalValues.fulfilledSumKg.toFixed(2) +
              '(KG) | ' +
              totalValues.fulfilledSumUnit.toFixed(2) +
              '(UNIT)'}
          </center>
        </h4>
        <h4>
          <center>
            {'Remaining Quantity : ' +
              totalValues.remainingKG.toFixed(2) +
              '(KG) | ' +
              totalValues.remainingUnit.toFixed(2) +
              '(UNIT)'}
          </center>
        </h4>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>SKU</TableCell>
                  <TableCell align={'left'}>Crop Name</TableCell>
                  <TableCell align={'right'}>Quantity</TableCell>
                  <TableCell align={'right'}>Fulfilled Quantity</TableCell>
                  <TableCell align={'right'}>Short Supply</TableCell>
                  <TableCell align={'right'}>Measuring Unit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableDataNew.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell
                      align={'left'}
                      component="th"
                      scope="row"
                      style={{ borderBottom: 'none' }}
                    >
                      {data.productCode}
                    </TableCell>
                    <TableCell
                      align={'left'}
                      component="th"
                      scope="row"
                      style={{ borderBottom: 'none' }}
                    >
                      {data.proName}
                    </TableCell>
                    <TableCell
                      align={'right'}
                      component="th"
                      scope="row"
                      style={{ borderBottom: 'none' }}
                    >
                      {parseFloat(data.quantity).toFixed(2)}
                    </TableCell>
                    <TableCell
                      align={'right'}
                      component="th"
                      scope="row"
                      style={{ borderBottom: 'none' }}
                    >
                      {parseFloat(data.fulfilledQuantity).toFixed(2)}
                    </TableCell>
                    <TableCell
                      align={'right'}
                      component="th"
                      scope="row"
                      style={{ borderBottom: 'none' }}
                    >
                      {parseFloat(data.shortSupplyAmount).toFixed(2)}
                    </TableCell>
                    <TableCell
                      align={'right'}
                      component="th"
                      scope="row"
                      style={{ borderBottom: 'none' }}
                    >
                      {data.measuringUnitName}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <h4>
          <center>----End of the list----</center>
        </h4>
      </div>
    );
  }
}
